// datatable related plugins
import Breadcrumbs from "components/Common/Breadcrumb";
import ConfirmModal from "components/shared-components/ConfirmModal";
import CustomDateFilter from "components/shared-components/RemoteTable/custom-date-filter";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_NEW,
  AUTH_STATUS_PROGRESSING,
  REGISTRY_INVOICE_FIELD,
} from "constants/FormatDataContanst";
import { CUSTOM_DATE_FILTER_TABLE_TYPE } from "constants/RemoteDataTableContanst";
import { formConvertErrorMessage } from "helpers/form_helper";
import { tableFormateDate } from "pages/DataFormatInvoice/utils";
import React, { useEffect, useState } from "react";
import { customFilter, textFilter } from "react-bootstrap-table2-filter";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import { Card, CardBody, Col, Row } from "reactstrap";
import { getListBUChild } from "store/dashboard/actions";
import {
  CREATE_USER_INVOICE_FAIL,
  CREATE_USER_INVOICE_SUCCESS,
  DELETE_USER_INVOICE_FAIL,
  DELETE_USER_INVOICE_SUCCESS,
  EDIT_USER_INVOICE_FAIL,
  EDIT_USER_INVOICE_SUCCESS,
} from "store/general-info/user/actionTypes";
import {
  deleteUserInvoice,
  getListUserInvoice,
  resetCreateUserInvoice,
  resetDeleteUserInvoice,
  resetEditUserInvoice,
  resetListUserInvoice,
  setColumnVisibleUserInvoice,
} from "store/general-info/user/actions";
import DetailData from "./DetailData";
import { getStatus } from "./helper/functionHelper";
import { modeDetail } from "./utils";

const ListData = props => {
  const [mode, setMode] = useState(null);
  const [modalDetail, setModalDetail] = useState(false);
  const [dataDetail, setDataDetail] = useState(null);
  const toggleViewDetailModal = () => setModalDetail(!modalDetail);

  const { addToast } = useToasts();

  const [columns, setColumns] = useState([]);

  const dispatch = useDispatch();
  const [idDetail, setIdDetail] = useState(null);
  // Confirm Delete modal
  const [modalConfirmDelete, setModalConfirmDelete] = useState(false);
  const toggleConfirmDeleteModal = () =>
    setModalConfirmDelete(!modalConfirmDelete);
  // store reducer
  const userInvoice = useSelector(state => state.userInvoice);
  const { loading, listData, totalCount, columnsVisible, params } =
    userInvoice.user;
  const history = useHistory();

  const { t, i18n } = useTranslation(["user"]);

  const [commonStatus, setCommonStatus] = useState(getStatus(t));

  useEffect(() => {
    setCommonStatus(getStatus(t));
  }, [t]);

  useEffect(() => {
    initColumn();
  }, [commonStatus]);

  useEffect(() => {
    switch (userInvoice.type) {
      case CREATE_USER_INVOICE_SUCCESS:
        addToast(
          t("message.create", {
            target: t("user"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggleViewDetailModal();
        dispatch(getListUserInvoice(params));
        dispatch(resetCreateUserInvoice());
        break;
      case CREATE_USER_INVOICE_FAIL:
        if (
          userInvoice.createUser.error.code === 422 &&
          userInvoice.createUser.error.fields.length > 0
        ) {
          userInvoice.createUser.error.fields
            .filter(item => item.field !== "tenant_code")
            .map(item => {
              addToast(
                formConvertErrorMessage(
                  item.message ||
                    t("message.create", {
                      target: t("user"),
                      status: t("message.error"),
                    }),
                  t,
                  t(`form.${item.field}`) + " không hợp lệ."
                ),
                { appearance: "error", autoDismiss: true }
              );
            });
        }
        dispatch(resetCreateUserInvoice());
        break;

      case EDIT_USER_INVOICE_SUCCESS:
        addToast(
          t("message.update", {
            target: t("user"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggleViewDetailModal();
        dispatch(getListUserInvoice(params));
        dispatch(resetEditUserInvoice());
        break;
      case EDIT_USER_INVOICE_FAIL:
        if (
          userInvoice.editUser.error.code === 422 &&
          userInvoice.editUser.error.fields.length > 0
        ) {
          userInvoice.editUser.error.fields
            .filter(item => item.field !== "tenant_code")
            .map(item => {
              addToast(
                formConvertErrorMessage(
                  item.message ||
                    t("message.update", {
                      target: t("user"),
                      status: t("message.error"),
                    }),
                  t,
                  t(`form.${item.field}`) + " không hợp lệ."
                ),
                { appearance: "error", autoDismiss: true }
              );
            });
        }
        dispatch(resetEditUserInvoice());
        break;

      case DELETE_USER_INVOICE_SUCCESS:
        addToast(
          t("message.delete", {
            target: t("user"),
            status: t("message.success"),
          }),
          {
            appearance: "success",
            autoDismiss: true,
          }
        );
        toggleConfirmDeleteModal();
        dispatch(getListUserInvoice(params));
        dispatch(resetDeleteUserInvoice());
        break;
      case DELETE_USER_INVOICE_FAIL:
        addToast(
          t("message.delete", {
            target: t("user"),
            status: t("message.error"),
          }),
          {
            appearance: "error",
            autoDismiss: true,
          }
        );
        dispatch(resetDeleteUserInvoice());
        break;
      default:
        break;
    }
  }, [userInvoice.type]);

  const Dashboard = useSelector(state => state.Dashboard);
  const { tenantCodeHeader } = Dashboard;

  // Action list chang tenantCode
  useEffect(() => {
    if (tenantCodeHeader) {
      //   params.page = 1;
      dispatch(getListUserInvoice(params));
    }
  }, [tenantCodeHeader]);

  useEffect(() => {
    if (userInvoice.listVat) {
      initColumn();
    }
  }, [userInvoice.listVat]);

  useEffect(() => {
    dispatch(getListBUChild());
    return () => {
      dispatch(resetListUserInvoice());
    };
  }, []);

  const initColumn = () => {
    if (Object.keys(columnsVisible).length !== 0) {
      for (const item of initColumns) {
        if (columnsVisible[item.dataField] !== undefined) {
          item.hidden = !columnsVisible[item.dataField];
        }
      }
    }
    setColumns(initColumns);
  };

  const rowEvents = {
    onDoubleClick: (e, row, rowIndex) => {
      setDataDetail(row);
      setMode(modeDetail.VIEW);
      toggleViewDetailModal();
    },
  };

  const listRowAction = [
    {
      icon: <i className="bx bx-edit font-size-18 text-success" />,
      text: "Cập nhật",
      onClick: row => {
        setDataDetail(row);
        setMode(modeDetail.EDIT);
        toggleViewDetailModal();
      },
    },
    {
      icon: <i className="bx bx-trash font-size-18 text-danger" />,
      text: "Xóa",
      onClick: row => {
        setIdDetail(row.id);
        toggleConfirmDeleteModal();
      },
    },
  ];

  const OPTION_HTHUC = [
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD,
      label: t("select.hthuc_add"),
    },
    {
      value: REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT,
      label: t("select.hthuc_edit"),
    },
  ];

  const selectFilterHTHUC = {
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.ADD]:
      t("select.hthuc_add"),
    [REGISTRY_INVOICE_FIELD.COMMON.HTHUC.selectValues.EDIT]:
      t("select.hthuc_edit"),
  };

  //   const getAuthStatus = (status, id) => {
  //     let infoError = null;
  //     if (
  //       status === AUTH_STATUS_REJECT ||
  //       status === AUTH_STATUS_RRE ||
  //       status === AUTH_STATUS_RR
  //     ) {
  //       infoError = (
  //         <i
  //           style={{ cursor: "pointer" }}
  //           title="Hiển thị lý do từ chối"
  //           className="font-size-17 bx bx-info-circle text-danger"
  //           onClick={() => {
  //             setIdRelease(id);
  //             toggleErrorReleaseModal();
  //           }}
  //         ></i>
  //       );
  //     }
  //     return (
  //       <React.Fragment>
  //         <div className="d-flex gap-1">
  //           <Badge
  //             className={`font-size-12 ${commonStatus?.AUTH_STATUS[status]?.badgeColor}`}
  //             pill
  //           >
  //             {commonStatus?.AUTH_STATUS[status]?.text}
  //           </Badge>
  //           {infoError}
  //         </div>
  //       </React.Fragment>
  //     );
  //   };

  const selectFilterAuthStatus = {
    [AUTH_STATUS_NEW]: commonStatus?.AUTH_STATUS[AUTH_STATUS_NEW]?.text, // "Lưu tạm",
    [AUTH_STATUS_PROGRESSING]:
      commonStatus?.AUTH_STATUS[AUTH_STATUS_PROGRESSING]?.text, // "Đang xử lý",
    [AUTH_STATUS_APPROVE]: commonStatus?.AUTH_STATUS[AUTH_STATUS_APPROVE]?.text, // "Hoàn tất",
  };

  const selectTypeId = {
    1: "Doanh nghiệp",
    2: "Khách lẻ",
  };

  const initColumns = [
    {
      dataField: "id",
      text: "Id",
      sort: true,
      hidden: true,
    },
    {
      dataField: "code",
      text: "Code",
      // filter: textFilter({
      //   placeholder: t("placeholder.enter"),
      // }),
    },
    {
      dataField: "display_name",
      text: t("form.display_name"),
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    {
      dataField: "email",
      text: "Email",
      filter: textFilter({
        placeholder: t("placeholder.enter"),
      }),
    },
    // {
    //   dataField: "username",
    //   text: t("form.username"),
    //   filter: textFilter({
    //     placeholder: t("placeholder.enter"),
    //   }),
    // },
    {
      dataField: "checker_date",
      text: "Ngày cập nhật",
      hidden: false,
      formatter: (cellContent, row) => tableFormateDate(row.checker_date),
      filter: customFilter({
        type: CUSTOM_DATE_FILTER_TABLE_TYPE,
      }),
      filterRenderer: (onFilter, column) => (
        <CustomDateFilter
          onFilter={onFilter}
          column={column}
          paramFilter={params.columnFilter}
        />
      ),
    },
  ];

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder, columnFilter }
  ) => {
    params.sort = sortField ? sortOrder + sortField : params.sort;
    params.columnFilter = columnFilter;
    params.page = page;
    params.sizePerPage = sizePerPage;
    dispatch(getListUserInvoice(params));
  };

  const onSearchAllHandle = value => {
    params.keywords = value;
    dispatch(getListUserInvoice(params));
  };

  const optionShowColumnHandel = (field, value) => {
    const targetColumn = columns.find(item => item.dataField === field);
    if (targetColumn) {
      targetColumn.hidden = !value;
    }
    setColumns(columns);
    dispatch(setColumnVisibleUserInvoice(field, value));
  };

  const resetDataFunc = () => {
    dispatch(getListUserInvoice(params));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Danh sách User</title>
        </MetaTags>
        <div className="container-fluid">
          <Breadcrumbs
            title=""
            breadcrumbItem={"Danh sách User" + ` (${totalCount})`}
          />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <React.Fragment>
                    <ConfirmModal
                      isOpen={modalConfirmDelete}
                      titleHeader={"Xác nhận xóa User"}
                      titleBody={"Hệ thống sẽ thực hiện xóa User này ?"}
                      isDisableButton={userInvoice.deleteUser.loading}
                      onConfirm={note => {
                        dispatch(deleteUserInvoice(idDetail));
                      }}
                      textBtnConfirm={"Xác nhận"}
                      textBtnCancel={"Đóng"}
                      toggle={toggleConfirmDeleteModal}
                    />
                    <DetailData
                      dataDetail={dataDetail}
                      isOpenModal={modalDetail}
                      toggleModal={toggleViewDetailModal}
                      mode={mode}
                    />
                    <RemoteDataTable
                      keyField="id"
                      data={listData}
                      columns={columns}
                      page={params.page}
                      listRowAction={listRowAction}
                      sizePerPage={params.sizePerPage}
                      totalSize={totalCount}
                      loading={loading}
                      onTableChange={handleTableChange}
                      onSearchAllHandle={onSearchAllHandle}
                      optionShowColumnHandel={optionShowColumnHandel}
                      rowEvents={rowEvents}
                    >
                      {/* <Button
                        type="button"
                        color="primary"
                        className="me-2 btn-label"
                        onClick={() => {
                          setDataDetail(null);
                          setMode(modeDetail.CREATE);
                          toggleViewDetailModal();
                        }}
                      >
                        <i className="bx bx-plus label-icon" />
                        Thêm mới
                      </Button> */}
                    </RemoteDataTable>
                  </React.Fragment>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ListData;
